import DateTime from "../../Components/DateTime";
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import PageTabs from "../../Components/PageTabs";
import MainButton from "../../Props/MainButton";
import AlertBox from "../../Props/AlertBox";
import MyContext from "../../MyContext";
import PropTypes from "prop-types";
import TransactionTypeSetting from "../../../API/APIServices/TransactionTypeSetting";
import BillSeriesMaster from "../../../API/APIServices/BillSeriesMaster";
import WebTemplate from "../../../API/APIServices/WebTemplate";
import BillSeriesWiseTemplateSetting from "../../../API/APIServices/BillSeriesWiseTemplateSetting";
import Loader from "../../../Inventory/Props/Loader"

function VoucherWiseReportSetting({ setSliderCallBack, modelOpen }) {
  VoucherWiseReportSetting.propTypes = {
    fetchData: PropTypes.func.isRequired,
    setSliderCallBack: PropTypes.func.isRequired,
    editData: PropTypes.object,
    modelOpen: PropTypes.bool.isRequired,
  };

  const {
    OpenAlertBox,
    alertBox,
    OpenAlertBoxEdit,
    alertBoxEdit,
    alertBoxDelete,
    OpenAlertBoxDelete,
  } = useContext(MyContext);

  useState(() => {
    document.title = "Bill Series Wise Report Settings";
  }, []);

  const [loading, setLoading] = useState(false);

  const [, setModalOpen] = useState(false);
  const showModal = () => {
    setModalOpen(true);
  };
  const [inputValues, setInputValues] = useState({
    // printType: 0,
    // voucherSeries: 0,
    // reportTemplateId: 0,
    // showPrintOptionPopup: false,
    // formate1_Btn: false,
    // formate2_Btn: false,
    // sendMsg_Btn: false,
    // sendEmail_Btn: false,
    // printBarcode_Btn: false,

    printType: 0,
    voucherSeries: 0,
    showPrintOptionPopup: true,
    exOption1: true,
    exOption2: true,
    exOption3: "",
    exOption4: "",
    exOption5: "",
    printWindowBtnSetting: [
      {
        btnId: 0,
        templateId: 0,
        hideShow: true,
        btnType: "0",
        btnNameByUser: "",
        ex1: "",
        ex2: "",
        ex3: ""
      }
    ]

  });

  const [options, setOptions] = useState([]);
  const [templateData, setTemplateData] = useState([]);
  const [billSettData, setBillSettData] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [billSettId, setBillSettId] = useState(0);

  const fetchData1 = async () => {


    try {
      const response =
        await TransactionTypeSetting.GetAllTransactionTypeMaster();
      const response2 = await BillSeriesMaster.getBillSeriesMaster();

      if (
        response2 &&
        Array.isArray(response2) &&
        response &&
        Array.isArray(response)
      ) {
        const optionsData = response2
          .filter((billSeries) => billSeries.billSeriesName)
          .map((billSeries) => {
            const transactionType = response.find(
              (type) => type.id === billSeries.parentGrpMasterId
            );
            return {
              id: billSeries.id,
              billSeriesName: billSeries.billSeriesName,
              transactionTypeName: transactionType?.masterName || "Unknown",
              transactionTypeId: billSeries.parentGrpMasterId,
            };
          });

        return optionsData;
      } else {
        console.error("Error:", response.errorMessages);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const memoizedOptions = useMemo(() => {
    if (isDataFetched) {
      return options;
    }

    return [];
  }, [options, isDataFetched]);

  useEffect(() => {
    if (!isDataFetched) {
      fetchData1().then((data) => {
        setOptions(data);
        setIsDataFetched(true);
      });
    }
  }, [isDataFetched]);

  useEffect(() => {
    if (memoizedOptions.length > 0) {
      setOptions(memoizedOptions);
    }
  }, [memoizedOptions]);

  const fetchTemplateData = async () => {
    try {
      const response = await WebTemplate.GetCustomizedPageTemplates();
      if (response) {
        setTemplateData(response);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchTemplateData();
  }, []);

  const fetchBillSettingData = async () => {

    setLoading(true);
    try {
      const response =
        await BillSeriesWiseTemplateSetting.GetAllBillSeriesWiseTemplateSetting();
      if (response.isSuccess) {
        console.log("response.Result", response.result);
        setBillSettData(response.result);
      }
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  };
  useEffect(() => {
    fetchBillSettingData();
  }, []);

  useEffect(() => {
    console.log("inputValues", inputValues);
  }, [inputValues]);

  const printTypeRef = useRef(null);
  const voucherSeriesRef = useRef(null);
  const buttonTypeRef = useRef(null);
  const buttonNameRef = useRef(null);

  const [dynamicIndex, setDynamicIndex] = useState(-1);

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  
  const SaveBtn = async () => {

    ;

    if (!inputValues.voucherSeries) {

      voucherSeriesRef.current.focus();
      alert("Please select Print Type!");
      return;
    }


    for (let i = 0; i < inputValues.printWindowBtnSetting.length; i++) {

      if (inputValues.printWindowBtnSetting[i].btnType == "0") {
        setDynamicIndex(i);
        alert("Please select button type");
        
        await sleep(200);
        buttonTypeRef.current.focus();
        return;
      }

      if (!inputValues.printWindowBtnSetting[i].btnNameByUser) {
        setDynamicIndex(i);
        alert("Please enter button name");

        await sleep(200);
        buttonNameRef.current.focus();
        return;
      }

    }

    setLoading(true);
    var response;

    try {
      if (billSettId !== 0) {
        const data = {
          ...inputValues,
          id: billSettId,
        };
        response =
          await BillSeriesWiseTemplateSetting.UpdateBillSeriesWiseTemplateSetting(
            data
          );
      } else {
        response =
          await BillSeriesWiseTemplateSetting.CreateBillSeriesWiseTemplateSetting(
            inputValues
          );
      }
      if (response.isSuccess) {
        console.log("response", response);

        let message = billSettId === 0 ? "Data created successfully!" : "Data updated successfully!";
        alert(message);

        setInputValues({
          printType: 0,
          voucherSeries: 0,
          showPrintOptionPopup: true,
          exOption1: true,
          exOption2: true,
          exOption3: "",
          exOption4: "",
          exOption5: "",
          printWindowBtnSetting: [
            {
              btnId: 0,
              templateId: 0,
              hideShow: true,
              btnType: "0",
              btnNameByUser: "",
              ex1: "",
              ex2: "",
              ex3: ""
            }
          ]
        });

        fetchBillSettingData();
        setBillSettId(0);
      } else {
        console.log(response.errorMessages)
        alert("Failed to create or update the data!");
      }
    } catch (error) {
      console.error(error);
      alert("Failed to create or update the data!")
    }

    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const updatedValue = type === "checkbox" ? checked : value;

    setInputValues({
      ...inputValues,
      [name]: updatedValue,
    });
  };

  const handleInputChange2 = (key, value) => {

    let temp = { ...inputValues };
    temp[key] = value;

    setInputValues(temp);
  }

  // const buttonTypeMap = {

  //   0: "",
  //   1: "Formate 1"
  //   1: "Formate 2"
  //   1: "Formate 3"
  //   1: "Formate 4"
  //   1: "Formate 5"
  // };

  const handleInputChange3 = (key, value, index, text = "") => {

    console.log({ key, value, index })

    let temp = { ...inputValues };
    temp.printWindowBtnSetting[index][key] = value;

    if (key == "btnType") {

      temp.printWindowBtnSetting[index]["btnNameByUser"] = text;
    }

    setInputValues(temp);
  }

  const addRows = () => {

    let temp = { ...inputValues };

    temp.printWindowBtnSetting.push({
      btnId: 0,
      templateId: 0,
      hideShow: true,
      btnType: "",
      btnNameByUser: "",
      ex1: "",
      ex2: "",
      ex3: ""
    });

    setInputValues(temp);
  }

  const deleteRow = (index) => {

    let temp = { ...inputValues };

    if (temp.printWindowBtnSetting.length === 1) {
      setInputValues({
        ...inputValues,
        printWindowBtnSetting: [
          {
            btnId: 0,
            templateId: 0,
            hideShow: true,
            btnType: "0",
            btnNameByUser: "",
            ex1: "",
            ex2: "",
            ex3: ""
          }
        ]

      });

      return;
    }

    temp.printWindowBtnSetting = inputValues.printWindowBtnSetting.filter((data, i) => index !== i);
    setInputValues(temp);
  }

  const handleUpdate = async (id) => {

    if (billSettId == id) {

      setInputValues({
        printType: 0,
        voucherSeries: 0,
        showPrintOptionPopup: true,
        exOption1: true,
        exOption2: true,
        exOption3: "",
        exOption4: "",
        exOption5: "",
        printWindowBtnSetting: [
          {
            btnId: 0,
            templateId: 0,
            hideShow: true,
            btnType: "0",
            btnNameByUser: "",
            ex1: "",
            ex2: "",
            ex3: ""
          }
        ]
      });

      setBillSettId(0);
      return;
    }

    setLoading(true);
    try {

      const response =
        await BillSeriesWiseTemplateSetting.GetAllBillSeriesWiseTemplateSettingById(
          id
        );
      if (response.isSuccess) {
        setBillSettId(id);
        setInputValues(response.result);
        console.log("responseById", response);
      }
    } catch (error) {
      console.log(error);
      alert("Unable to fetch data!");
    }

    setLoading(false);
  };

  const handleDelete = async (id) => {

    setLoading(true);

    try {
      const response =
        await BillSeriesWiseTemplateSetting.DeleteBillSeriesWiseTemplateSettingById(
          id
        );
      if (response.isSuccess) {
        console.log("responseById", response);
        if (billSettId === id) {
          setBillSettId(0);
        }
      }
    } catch (error) {
      console.log(error)
      alert("Unable to delete data!")
    }

    fetchBillSettingData();

    setLoading(false);
  };

  function getPrintType(id) {

    const dict = {
      1: "Bill Print",
      2: "Barcode Print"
    };

    return dict[id] ? dict[id] : "";
  }

  return (
    <div>
      <PageTabs modelOpen={modelOpen} setSliderCallBack={setSliderCallBack} />
      <div className="panel-heading">
        <div className="panel-head-title">
          <h2 className="panel-title">Bill Series Wise Report Settings</h2>
        </div>
        {/* *******************Top Buttons****************** */}
        <MainButton
          SaveButton={SaveBtn}
          isBtnSetting={false}
          showModal={showModal}
          modelOpen={modelOpen}
          setSliderCallBack={setSliderCallBack}
        />
      </div>

      <div>
        <DateTime />
      </div>
      <div className="content_box">
        <div className="company-info-top-im">
          <div className="tab-head">
            <div id="tabs">
              <div className="tab-content-box">
                <div className="tab-content-1">
                  <div className="company-info-top-right control_flex_m1" style={{ paddingBottom: "0px" }}>
                    <div className="control_radius">
                      <div className="company_info-text-im depart_top">
                        Bill Series Wise Report Settings
                      </div>
                      <div className="company_control">

                        <div style={{display:"none"}} className="stock-im-dep1">
                          <div className="input-box-Imo1 input-height2">
                            <div className="input-box-mok1">
                              <select
                                ref={printTypeRef}
                                className="modify_im_input mode_category1"
                                onChange={(e) => handleInputChange2(e.target.name, Number(e.target.value))}
                                type="text"
                                name="printType"
                                value={inputValues.printType}
                                required
                              >
                                <option value="0">--Select Report Type--</option>
                                <option value="1">Bill Print</option>
                                <option value="2">Barcode Print</option>
                              </select>
                              <label class="modify_lbl_text3">Print Type</label>
                            </div>
                          </div>
                        </div>

                        <div className="stock-im-dep1">
                          <div className="input-box-Imo1 input-height2 flex-report-for">
                            <div className="input-box-mok1">
                              <select
                                ref={voucherSeriesRef}
                                className="modify_im_input mode_category1"
                                onChange={(e) => handleInputChange2(e.target.name, Number(e.target.value))}
                                name="voucherSeries"
                                value={inputValues.voucherSeries}
                                required
                              >
                                <option value="0">--Select--</option>
                                {options.map((option, index) => (
                                  <option key={index} value={option.id}>
                                    {option.billSeriesName} {" - "}{" "}
                                    {`(${option.transactionTypeName})`}
                                  </option>
                                ))}
                              </select>
                              <label className="modify_lbl_text3">
                                Select Voucher Series
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="company_control" style={{padding: "0px 10px"}}>
                        {/* <div className="stock-im-dep1">
                          <div className="input-box-Imo1 input-height2 flex-report-for">
                            <div className="input-box-mok1">
                              <select
                                className="modify_im_input mode_category1"
                                onChange={handleInputChange}
                                name="reportTemplateId"
                                value={inputValues.reportTemplateId}
                                required
                              >
                                <option value="">--Select--</option>
                                {templateData.map((data, index) => (
                                  <option key={index} value={data.id}>
                                    {data.name}
                                  </option>
                                ))}
                              </select>
                              <label className="modify_lbl_text3">
                                Select Template Name
                              </label>
                            </div>
                          </div>
                        </div> */}

                        <div className="stock-im-dep1">
                          <div className="input-box-Imo1 input-height2">
                            <div className="input-box-mok1 voucher-wise-report-setting-show-print-window">
                              <div>
                                Show Print Window
                              </div>
                              <input
                                type="checkbox"
                                name="showPrintOptionPopup"
                                checked={inputValues.showPrintOptionPopup}
                                onChange={(e) => handleInputChange2(e.target.name, e.target.checked)}
                                className="toggle-input"
                                style={{}}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <div className="company_control">
                        <div className="stock-im-dep1">
                          <div className="input-box-Imo1 input-height2 flex-report-for">
                            <div className="input-box-mok1"></div>
                          </div>
                        </div>

                        <div className="stock-im-dep1">
                          <div className="input-box-Imo1 input-height2">
                            <div className="input-box-mok1">
                              {inputValues.showPrintOptionPopup && (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <label
                                      className="modify_p_text2"
                                      style={{
                                        position: "relative",
                                        top: "0",
                                        left: "10px",
                                      }}
                                    >
                                      Show Format 1
                                    </label>
                                    <input
                                      type="checkbox"
                                      name="formate1_Btn"
                                      checked={inputValues.formate1_Btn}
                                      onChange={handleInputChange}
                                      className="toggle-input"
                                    />
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <label
                                      className="modify_p_text2"
                                      style={{
                                        position: "relative",
                                        top: "0",
                                        left: "10px",
                                      }}
                                    >
                                      Show Format 2
                                    </label>
                                    <input
                                      type="checkbox"
                                      name="formate2_Btn"
                                      checked={inputValues.formate2_Btn}
                                      onChange={handleInputChange}
                                      className="toggle-input"
                                    />
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <label
                                      className="modify_p_text2"
                                      style={{
                                        position: "relative",
                                        top: "0",
                                        left: "10px",
                                      }}
                                    >
                                      Send Message
                                    </label>
                                    <input
                                      type="checkbox"
                                      name="sendMsg_Btn"
                                      checked={inputValues.sendMsg_Btn}
                                      onChange={handleInputChange}
                                      className="toggle-input"
                                    />
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <label
                                      className="modify_p_text2"
                                      style={{
                                        position: "relative",
                                        top: "0",
                                        left: "10px",
                                      }}
                                    >
                                      Send Email
                                    </label>
                                    <input
                                      type="checkbox"
                                      name="sendEmail_Btn"
                                      checked={inputValues.sendEmail_Btn}
                                      onChange={handleInputChange}
                                      className="toggle-input"
                                    />
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <label
                                      className="modify_p_text2"
                                      style={{
                                        position: "relative",
                                        top: "0",
                                        left: "10px",
                                      }}
                                    >
                                      Print Barcode
                                    </label>
                                    <input
                                      type="checkbox"
                                      name="printBarcode_Btn"
                                      checked={inputValues.printBarcode_Btn}
                                      onChange={handleInputChange}
                                      className="toggle-input"
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>



                      </div> */}

                      <div>

                        {inputValues.showPrintOptionPopup && (

                          <div
                            className="table-div"
                            style={{
                              maxHeight: "400px",
                              // overflowX: "auto",
                              overflowY: "auto",
                              marginBottom: "20px"
                            }}
                          >
                            <table className="tableList-main">
                              <thead className="table-head-main">
                                <tr>
                                  <th>Sno</th>
                                  <th>Show</th>
                                  <th>Button Type</th>
                                  <th>Button Name By User</th>
                                  <th>Template Name</th>
                                  <th>Delete</th>
                                </tr>
                              </thead>
                              <tbody className="table-body-main">

                                {inputValues.printWindowBtnSetting.map((data, index) => (

                                  <tr>
                                    <td>{index + 1}</td>

                                    <td>
                                      <input
                                        type="checkbox"
                                        name="hideShow"
                                        checked={data.hideShow}
                                        onChange={(e) => handleInputChange3(e.target.name, e.target.checked, index)}
                                        className="toggle-input"
                                      />
                                    </td>

                                    <td>

                                      <select
                                        className="modify_im_input mode_category1"
                                        onChange={(e) => handleInputChange3(e.target.name, e.target.value, index, e.target.options[e.target.selectedIndex].text)}
                                        name="btnType"
                                        value={data.btnType}
                                        ref={index == dynamicIndex ? buttonTypeRef : null}
                                        required
                                      >
                                        <option value="0">--Select--</option>
                                        <option value="1">Formate 1</option>
                                        <option value="2">Formate 2</option>
                                        <option value="3">Formate 3</option>
                                        <option value="4">Formate 4</option>
                                        <option value="5">Formate 5</option>
                                        <option value="6">Send SMS</option>
                                        <option value="7">Send Email</option>
                                        <option value="10">Whatsapp Business API</option>
                                        <option value="8">Share</option>
                                        <option value="9">Barcode</option>

                                      </select>
                                    </td>

                                    <td>
                                      <input ref={index == dynamicIndex ? buttonNameRef : null} type="text" value={data.btnNameByUser} name="btnNameByUser"
                                        onChange={(e) => handleInputChange3(e.target.name, e.target.value, index)}
                                        className="modify_im_input mode_limit mode_category" />
                                    </td>

                                    <td>
                                      <select
                                        className="modify_im_input mode_category1"
                                        onChange={(e) => handleInputChange3(e.target.name, Number(e.target.value), index)}
                                        name="templateId"
                                        value={data.templateId}
                                        required
                                      >
                                        <option value={0}>--Select--</option>
                                        {templateData.map((data, index) => (
                                          <option key={index} value={data.id}>
                                            {data.name}
                                          </option>
                                        ))}
                                      </select>
                                    </td>

                                    <td>
                                      <i onClick={() => deleteRow(index)} className="fa-regular fa-trash-can TableDelIcon" ></i>
                                    </td>
                                  </tr>
                                ))}

                              </tbody>

                              <span onClick={addRows} style={{ position: "relative", left: "25%" }}><i class="fa-solid fa-circle-plus dm_4" ></i></span>
                            </table>
                          </div>
                        )}

                        <div className="company_info-text-im depart_top">
                          Bill Series Wise Report Settings List
                        </div>

                        <div
                          className="table-div"
                          style={{
                            maxHeight: "400px",
                            // overflowX: "auto",
                            overflowY: "auto",
                          }}
                        >
                          <table className="tableList-main">
                            <thead className="table-head-main">
                              <tr>
                                <th>Sno</th>
                                <th>Voucher Series</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody className="table-body-main">
                              {billSettData.map((item, idx) => (
                                <tr key={item.id}>
                                  <td style={{ backgroundColor: billSettId == item.id ? "#b6b6b6" : "white" }}>{idx + 1}</td>
                                  <td style={{ backgroundColor: billSettId == item.id ? "#b6b6b6" : "white" }}>{item.voucherSeriesName}</td>
                                  <td style={{ backgroundColor: billSettId == item.id ? "#b6b6b6" : "white" }}>
                                    <i
                                      className="fa-regular fa-pen-to-square TableEditIcon"
                                      onClick={() => handleUpdate(item.id)}
                                    />
                                    <i
                                      className="fa-regular fa-trash-can TableDelIcon"
                                      onClick={() => handleDelete(item.id)}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {alertBoxDelete && (
        <AlertBox
          HeadingTop="DELETE"
          Heading="Are You sure you want to delete this"
          OpenAlertBox={OpenAlertBoxDelete}
        />
      )}
      {alertBox && (
        <AlertBox
          HeadingTop="Saved"
          Heading="Your Report Setting is Saved"
          onYesClick={OpenAlertBox}
          singleButton={true}
          OpenAlertBox={OpenAlertBox}
        />
      )}
      {alertBoxEdit && (
        <AlertBox
          HeadingTop="Updated"
          Heading="Your Report Setting is Updated"
          onYesClick={OpenAlertBoxEdit}
          singleButton={true}
          OpenAlertBox={OpenAlertBoxEdit}
        />
      )}

      {loading && <Loader />}
    </div>
  );
}

export default VoucherWiseReportSetting;
